module.exports = __webpack_public_path__ + "img/WD_JK.53a47f9e.png";